export class GoogleWorkspaceWholeUserRestore {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<GoogleWorkspaceUserRestoreSelection>",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceRestoreWorkload>",
            "format": ""
        },
        {
            "name": "drive",
            "baseName": "drive",
            "type": "GoogleWorkspaceDriveRestoreOptions",
            "format": ""
        },
        {
            "name": "gmail",
            "baseName": "gmail",
            "type": "GoogleWorkspaceGmailRestoreOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceWholeUserRestore.attributeTypeMap;
    }
    constructor() {
    }
}
